import {
  deleteRequest,
  get,
  post,
  put,
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";


export const getContractList = async (): Promise<DataResponse<any>> => {
  const url = `${endpoints.getContractList}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getContractDetails = async (contractId:string): Promise<DataResponse<any>> => {
  const url = `${endpoints.getContractDetails}/${contractId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};


export const addContract = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addContract}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};

export const editContract = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.editContract}/${data.id}`;
  const config = headers.content_type.application_json;
  return put<DataResponse<any>>(url, data, config);
};

export const deleteContract = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.deleteContract}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data, config);
};

